export default __webpack_public_path__ + "static/Project-Impact-b040f4a96670af6fc8544bf8b960960b.webp";